<template>
  <div>
    <v-tabs
      v-if="orientation === 'horizontal'"
      v-model="model"
      :color="$vuetify.theme.dark ? 'white' : 'black'"
      grow
      icons-and-text
      height="70"
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-container>
        <v-row align="stretch" class="height-70" :class="scrollClass">
          <v-tab
            v-for="game in $breakpoint.mdAndUp
              ? menuItemsData
              : menuMobileItemsData"
            :id="game.id"
            :key="game.id"
            class="caption px-1"
            :to="`/sportsbook/${game.id}`"
          >
            <v-badge
              class="mt-3"
              color="primary"
              :content="
                game.name
                  ? game.name === 'Cricket'
                    ? cricketEventsCount
                    : game.name === 'Soccer'
                    ? soccerEventsCount
                    : game.name === 'Tennis'
                    ? tennisEventsCount
                    : game.name === 'Election'
                    ? electionEventsCount
                    : 0
                  : 0
              "
              :value="
                game.name
                  ? game.name === 'Cricket'
                    ? cricketEventsCount
                    : game.name === 'Soccer'
                    ? soccerEventsCount
                    : game.name === 'Tennis'
                    ? tennisEventsCount
                    : game.name === 'Election'
                    ? electionEventsCount
                    : 0
                  : 0
              "
            >
              {{ game.name }}
            </v-badge>
            <v-img
              class="mb-1"
              width="22"
              max-height="22"
              contain
              rounded
              :src="getIcon(game.imgName)"
            ></v-img>
          </v-tab>
        </v-row>
      </v-container>
    </v-tabs>

    <v-list v-else class="left-panel d-flex vertical-list" :class="scrollClass">
      <div
        v-if="!$route.params.category && !$route.params.subCategory"
        class="col-12 px-0 games game-left one"
      >
        <template v-for="game in menuItemsData.slice(0, limitBy)">
          <v-list-item
            :id="game.id"
            :key="game.id"
            :to="
              game.redirectType
                ? `/${game.redirectType}/${game.redirect}`
                : `/${game.redirect}`
            "
            dense
          >
            <v-list-item-avatar tile size="22">
              <v-img :src="getIcon(game.imgName)"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title
                style="text-align: start"
                @click="setRedirect(`/${game.redirectId}`)"
              >
                {{ game.name }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="cricketEventsCount > 0">
              <v-badge
                class="ma-0"
                color="primary"
                :content="
                  game.name
                    ? game.name === 'Cricket'
                      ? cricketEventsCount
                      : game.name === 'Soccer'
                      ? soccerEventsCount
                      : game.name === 'Tennis'
                      ? tennisEventsCount
                      : game.name === 'Election'
                      ? electionEventsCount
                      : 0
                    : 0
                "
                :value="
                  game.name
                    ? game.name === 'Cricket'
                      ? cricketEventsCount
                      : game.name === 'Soccer'
                      ? soccerEventsCount
                      : game.name === 'Tennis'
                      ? tennisEventsCount
                      : game.name === 'Election'
                      ? electionEventsCount
                      : 0
                    : 0
                "
                inline
              >
              </v-badge>
            </v-list-item-action>
          </v-list-item>
          <v-divider :key="'divider' + game.name"></v-divider>
        </template>
        <!-- Static menu for Casino and Cardgames -->
        <div class="d-block">
          <v-list-item
            v-if="!$auth.user || $auth.user.cardgame"
            to="/live-cards"
          >
            <div class="v-list-item--dense v-list-item--link d-flex">
              <div class="v-avatar rounded-0 v-avatar--tile pr-4">
                <div class="v-image v-responsive theme--dark">
                  <div class="v-responsive"></div>
                  <v-img
                    max-height="25"
                    max-width="25"
                    class="v-image__image v-image__image--cover rounded"
                    :src="cardicon"
                  ></v-img>
                  <div class="v-responsive"></div>
                </div>
              </div>
              <div class="v-list-item__content">
                <div class="v-list-item__title">Live Card</div>
              </div>
            </div>
          </v-list-item>
          <hr
            v-if="!$auth.user || $auth.user.cardgame"
            class="v-divider"
            :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
          />
          <v-list-item
            v-if="!$auth.user || $auth.user.casino"
            id="casino"
            to="/casino/live-casino"
          >
            <div class="v-list-item--dense v-list-item--link d-flex">
              <div class="v-avatar rounded-0 v-avatar--tile pr-4">
                <div class="v-image v-responsive theme--dark">
                  <div class="v-responsive"></div>
                  <v-img
                    max-height="25"
                    max-width="25"
                    class="v-image__image v-image__image--cover rounded"
                    :src="casino"
                  ></v-img>
                  <div class="v-responsive"></div>
                </div>
              </div>
              <div class="v-list-item__content">
                <div class="v-list-item__title">Casino</div>
              </div>
            </div>
          </v-list-item>
          <hr
            v-if="!$auth.user || $auth.user.cardgame"
            class="v-divider"
            :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
          />
          <v-list-item
            v-if="!$auth.user || $auth.user.casino"
            to="/casino-slots"
          >
            <div class="v-list-item--dense v-list-item--link d-flex">
              <div class="v-avatar rounded-0 v-avatar--tile pr-4">
                <div class="v-image v-responsive theme--dark">
                  <div class="v-responsive"></div>
                  <v-img
                    max-height="25"
                    max-width="25"
                    class="v-image__image v-image__image--cover rounded"
                    :src="sloticon"
                  ></v-img>
                  <div class="v-responsive"></div>
                </div>
              </div>
              <div class="v-list-item__content">
                <div class="v-list-item__title">Slot Games</div>
              </div>
            </div>
          </v-list-item>
          <hr
            v-if="!$auth.user || $auth.user.casino"
            class="v-divider"
            :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
          />
          <v-list-item
            v-if="
              (!$auth.user || $auth.user.horseRacing) &&
              domain === 'playtowin.club'
            "
            to="/racing"
          >
            <div class="v-list-item--dense v-list-item--link d-flex">
              <div class="v-avatar rounded-0 v-avatar--tile pr-4">
                <div class="v-image v-responsive theme--dark">
                  <div class="v-responsive"></div>
                  <v-img
                    max-height="25"
                    max-width="25"
                    class="v-image__image v-image__image--cover rounded"
                    :src="require('@/assets/images/menu/Horse-Racing.png')"
                  ></v-img>
                  <div class="v-responsive"></div>
                </div>
              </div>
              <div class="v-list-item__content">
                <div class="v-list-item__title">Horse Racing</div>
              </div>
            </div>
          </v-list-item>
          <hr
            v-if="
              (!$auth.user || $auth.user.horseRacing) &&
              domain === 'playtowin.club'
            "
            class="v-divider"
            :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
          />
          <hr
            v-if="domain == 'playtowin.club'"
            class="v-divider"
            :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
          />
          <template v-for="(premiumSportsbook, index) in premiumSportsbookData">
            <v-list-item
              v-if="
                (!$auth.user ||
                  !$auth.user.loggedIn ||
                  $auth.user.premiumsportsbook) &&
                index < limitBy
              "
              :id="premiumSportsbook.name"
              :key="premiumSportsbook._id"
              :to="`/premium-sportsbook?bt-path=${premiumSportsbook.path}`"
              dense
            >
              <v-list-item-avatar tile size="22">
                <v-img :src="premiumSportsbook.logo"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title style="text-align: start">
                  {{ premiumSportsbook.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider
              v-if="index < limitBy"
              :key="'divider' + premiumSportsbook.name"
              class="v-divider"
              :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
            ></v-divider>
          </template>
          <template v-if="$auth.loggedIn && $breakpoint.mdAndUp">
            <v-list-item @click="viewMore(defaultLimit, menuItemsData.length)">
              <v-list-item-avatar tile size="22">
                <v-icon medium color="white"> {{ iconText }}</v-icon>
              </v-list-item-avatar>
              {{ limitBy === 10 ? 'View more' : 'View Less' }}
            </v-list-item>
          </template>
          <favorites v-if="$auth.loggedIn && $breakpoint.mdAndUp"></favorites>
        </div>
        <!-- Static menu for Casino and Cardgames -->
      </div>
      <!-- menu for compition -->
      <div
        v-if="$route.params.category && !$route.params.subCategory"
        class="col-12 px-0 games game-left two"
      >
        <v-list-item :to="`/sportsbook`">
          <v-list-item-avatar tile size="22">
            <v-icon>mdi-home</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title> Sports </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          id="game"
          :to="`/sportsbook/${gameName}`"
          dense
          class="primary"
        >
          <v-list-item-avatar tile size="22">
            <v-img :src="getIcon(gameName)"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ gameName }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          id="previous"
          dense
          class="primary-lighten"
          @click="goBack()"
        >
          <v-list-item-avatar tile size="22">
            <v-icon>mdi-chevron-left</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title> Previous </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <competitions v-if="!isEmpty" :compitions="compitions"></competitions>
        <favorites v-if="$auth.loggedIn && $breakpoint.mdAndUp"></favorites>
      </div>
      <!-- menu for EventCompetition -->
      <div
        v-if="$route.params.category && $route.params.subCategory"
        class="col-12 px-0 games game-left three"
      >
        <v-list-item id="game" :to="`/sportsbook`">
          <v-list-item-avatar tile size="22">
            <v-icon>mdi-home</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title> Sports </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          id="game"
          :to="`/sportsbook/${gameName}`"
          dense
          class="primary"
        >
          <v-list-item-avatar tile size="22">
            <v-img :src="getIcon(gameName || gameNameEvent)"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ gameName || gameNameEvent }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          id="previous"
          class="primary-lighten"
          dense
          @click="goBack()"
        >
          <v-list-item-avatar tile size="22">
            <v-icon>mdi-chevron-left</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title> Previous </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <event-competitions
          :event-compitions="eventCompitions"
        ></event-competitions>
        <favorites v-if="$auth.loggedIn && $breakpoint.mdAndUp"></favorites>
      </div>
    </v-list>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EventCompetitions from '@/components/EventCompetitions'
import Competitions from '@/components/Competitions'
import casino from '@/assets/images/sportsbook-categories/casino.png'
import cardicon from '@/assets/images/sportsbook-categories/cardicon.png'
import sloticon from '@/assets/images/sportsbook-categories/sloticon.png'
import kabaddi from '@/assets/images/sportsbook-categories/kabaddi.png'
import badminton from '@/assets/images/sportsbook-categories/badminton.png'
import golf from '@/assets/images/sportsbook-categories/golf.png'
import baseball from '@/assets/images/sportsbook-categories/baseball.png'
import cs from '@/assets/images/sportsbook-categories/cs.png'
import rugby from '@/assets/images/sportsbook-categories/rugby.png'
import boxing from '@/assets/images/sportsbook-categories/boxing.png'
import fifa from '@/assets/images/sportsbook-categories/fifa.png'
import dota from '@/assets/images/sportsbook-categories/dota.png'
import tableTennis from '@/assets/images/sportsbook-categories/table-tennis.png'
import efighting from '@/assets/images/sportsbook-categories/efighting.png'
import formula from '@/assets/images/sportsbook-categories/formula.png'
import virtual from '@/assets/images/sportsbook-categories/virtual.png'
import voleyball from '@/assets/images/sportsbook-categories/voleyball.png'
import basketball from '@/assets/images/sportsbook-categories/basketball.png'
import horse from '@/assets/images/sportsbook-categories/horse.png'
import greyhound from '@/assets/images/sportsbook-categories/greyhound.png'
import Favorites from '@/components/Favorites'

export default {
  name: 'SportbookCategory',
  components: { EventCompetitions, Competitions, Favorites },
  props: {
    orientation: { type: String, default: 'horizontal' },
    isEmpty: { type: Boolean, default: false }
  },
  data() {
    return {
      model: null,
      scrollClass: 'left-main',
      casino,
      cardicon,
      iconText: 'mdi-chevron-down',
      sloticon,
      kabaddi,
      baseball,
      cs,
      rugby,
      badminton,
      fifa,
      dota,
      tableTennis,
      efighting,
      formula,
      virtual,
      voleyball,
      basketball,
      boxing,
      golf,
      horse,
      greyhound,
      domain: process.env.DOMAIN_NAME,
      menuMobileItemsData: [
        {
          name: 'Cricket',
          imgName: 'Cricket',
          id: '4',
          redirect: 'Cricket',
          redirectType: 'sportsbook'
        },
        {
          name: 'Soccer',
          imgName: 'Soccer',
          id: '1',
          redirect: 'Soccer',
          redirectType: 'sportsbook'
        },
        {
          name: 'Tennis',
          imgName: 'Tennis',
          id: '2',
          redirect: 'Tennis',
          redirectType: 'sportsbook'
        }
      ],
      menuItemsData: [
        {
          name: 'Cricket',
          imgName: 'Cricket',
          id: '4',
          redirect: 'Cricket',
          redirectType: 'sportsbook'
        },
        {
          name: 'Soccer',
          imgName: 'Soccer',
          id: '1',
          redirect: 'Soccer',
          redirectType: 'sportsbook'
        },
        {
          name: 'Tennis',
          imgName: 'Tennis',
          id: '2',
          redirect: 'Tennis',
          redirectType: 'sportsbook'
        },
        // {
        //   name: 'Election',
        //   imgName: 'Election',
        //   id: '5',
        //   redirect: 'Election'
        // },
        {
          name: 'Live Card',
          imgName: 'cardicon',
          id: '6',
          redirect: 'live-cards',
          redirectType: 'markets'
        },
        {
          name: 'Casino',
          imgName: 'casino',
          id: '7',
          redirect: 'live-casino',
          redirectType: 'markets'
        },
        {
          name: 'Slot Games',
          imgName: 'sloticon',
          id: '8',
          redirect: 'casino-slots'
        },
        {
          name: 'Kabaddi',
          imgName: 'kabaddi',
          id: '9',
          redirectId: '138',
          redirect: 'premium-sportsbook'
        },
        {
          name: 'Badminton',
          imgName: 'badminton',
          id: '10',
          redirectId: '31',
          redirect: 'premium-sportsbook'
        },
        {
          name: 'Golf',
          imgName: 'golf',
          id: '11',
          redirect: 'premium-sportsbook',
          redirectId: '9'
        },
        {
          name: 'Baseball',
          imgName: 'baseball',
          id: '12',
          redirectId: '3',
          redirect: 'premium-sportsbook'
        },
        {
          name: 'Counter Strike',
          imgName: 'cs',
          id: '13',
          redirect: 'premium-sportsbook',
          redirectId: '109'
        },
        {
          name: 'Rugby',
          imgName: 'rugby',
          id: '14',
          redirectId: '12',
          redirect: 'premium-sportsbook'
        },
        {
          name: 'Boxing',
          imgName: 'boxing',
          id: '15',
          redirectId: '10',
          redirect: 'premium-sportsbook'
        },
        {
          name: 'FIFA',
          imgName: 'fifa',
          id: '16',
          redirectId: '300',
          redirect: 'premium-sportsbook'
        },
        {
          name: 'Voleyball',
          imgName: 'voleyball',
          id: '17',
          redirectId: '23',
          redirect: 'premium-sportsbook'
        },
        {
          name: 'Dota 2',
          imgName: 'dota',
          id: '18',
          redirectId: '111',
          redirect: 'premium-sportsbook'
        },
        {
          name: 'Virtual',
          imgName: 'virtual',
          id: '19',
          redirectId: '',
          redirect: 'premium-sportsbook'
        },
        {
          name: 'eFighting',
          imgName: 'efighting',
          id: '20',
          redirectId: '304',
          redirect: 'premium-sportsbook'
        },
        {
          name: 'Table Tennis',
          imgName: 'table-tennis',
          id: '21',
          redirectId: '20',
          redirect: 'premium-sportsbook'
        },
        {
          name: 'Formula 1',
          imgName: 'formula',
          id: '22',
          redirectId: '40',
          redirect: 'premium-sportsbook'
        }
      ],
      defaultLimit:
        this.$breakpoint.smAndDown && this.menuItemsData
          ? this.menuItemsData.length
          : 10,
      limitBy:
        this.$breakpoint.smAndDown && this.menuItemsData
          ? this.menuItemsData.length
          : 10,
      cricketEventsCount: 0,
      soccerEventsCount: 0,
      tennisEventsCount: 0,
      electionEventsCount: 0
    }
  },
  computed: {
    gameName() {
      const gamename = this.menuItemsData.filter(
        (item) => item.id === this.$route.params.category.length
      )
      if (this.$route.params.category.length > 2) {
        return this.$route.params.category
      }
      return gamename[0]?.name
    },
    gameNameEvent() {
      const category = this.$route.params.category
      const gamename = this.menuItemsData.filter((item) => item.id === category)
      return gamename[0]?.name
    },
    userName() {
      return this.$store.state.auth.user
    },
    eventGameData() {
      return this.$route.params.subCategory
    },
    ...mapState({
      Auth: (state) => state.auth.user.data,
      games: (state) => state.sportsbookCategory.data,
      premiumSportsbookData: (state) =>
        state.sportsbookCategory.premiumSportsbookData,
      eventCompitions: (state) => state.sportsbookCategory.eventCompetionData,
      compitions: (state) => state.sportsbookCategory,
      loading: (state) => state.sportsbookCategory.loading
    })
  },
  watch: {
    $route() {
      if (this.$breakpoint.smAndDown) {
        this.getCatergory()
      }
    }
  },
  // created() {
  //   this.activeGames()
  // },
  created() {
    this.getCatergory()
    this.getEventCounts()
    setTimeout(() => {
      this.getEventCounts()
    }, 60000)
  },
  beforeDestroy() {
    this.$store.commit('sportsbookCategory/empty_data')
  },
  async mounted() {
    await this.setLimit()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getIcon(text) {
      try {
        return require(`@/assets/images/sportsbook-categories/${text
          .replace(/([a-z])([A-Z])/g, '$1-$2') // get all lowercase letters that are near to uppercase ones
          .replace(/[\s_]+/g, '-') // replace all spaces and low dash
          .toLowerCase()}.png`)
      } catch (error) {
        return ''
      }
    },
    setRedirect(url) {
      this.$store.dispatch('sportsbookCategory/getNewRedirect', url)
    },
    async getCatergory() {
      try {
        if (!this.$route.params.category && !this.$route.params.subCategory) {
          await this.$store.dispatch('sportsbookCategory/get')
          // await this.$store.dispatch('sportsbookCategory/getPremiumSportsbook')
          await this.setLimit()
          this.scrollClass = 'left-main'
        } else if (
          this.$route.params.category &&
          !this.$route.params.subCategory
        ) {
          this.scrollClass = 'left-main-category'
          // await this.$store.dispatch(
          //   'sportsbookCategory/getCompetition',
          //   this.$route.params.category
          // )
        } else if (
          this.$route.params.category &&
          this.$route.params.subCategory
        ) {
          this.scrollClass = 'left-main-subcategory'
          await this.$store.dispatch(
            'sportsbookCategory/getEventCompetition',
            this.$route.params.subCategory
          )
        } else {
          await this.$store.dispatch('sportsbookCategory/get')
          // await this.$store.dispatch('sportsbookCategory/getPremiumSportsbook')
          await this.setLimit()
        }
      } catch (error) {}
    },
    viewMore(defaultLimit, bookDataLength) {
      this.limitBy =
        this.limitBy === defaultLimit ? bookDataLength : defaultLimit
      this.iconText =
        this.limitBy === 10 ? 'mdi-chevron-down' : 'mdi-chevron-up'
    },
    setLimit() {
      if (this.menuItemsData) {
        this.limitBy = this.$breakpoint.smAndDown
          ? this.menuItemsData.length
          : 10
        this.defaultLimit = this.$breakpoint.smAndDown
          ? this.menuItemsData.length
          : 10
      }
    },
    async getEventCounts() {
      try {
        const isPublic = !localStorage.getItem('accessToken')

        const responseCricket = await this.$axios({
          method: 'get',
          baseURL: process.env.BASE_URL,
          url: isPublic
            ? 'public/exchange/odds/eventType/4'
            : '/exchange/odds/eventType/4',
          headers: {
            authorization: localStorage.getItem('accessToken')
          }
        })
        this.cricketEventsCount = responseCricket.data.result.length
        const responseSoccer = await this.$axios({
          method: 'get',
          baseURL: process.env.BASE_URL,
          url: isPublic
            ? 'public/exchange/odds/eventType/1'
            : '/exchange/odds/eventType/1',
          headers: {
            authorization: localStorage.getItem('accessToken')
          }
        })
        this.soccerEventsCount = responseSoccer.data.result.length
        const responseTennis = await this.$axios({
          method: 'get',
          baseURL: process.env.BASE_URL,
          url: isPublic
            ? 'public/exchange/odds/eventType/2'
            : '/exchange/odds/eventType/2',
          headers: {
            authorization: localStorage.getItem('accessToken')
          }
        })
        this.tennisEventsCount = responseTennis.data.result.length
        const responseElection = await this.$axios({
          method: 'get',
          baseURL: process.env.BASE_URL,
          url: isPublic
            ? 'public/exchange/odds/eventType/2378962'
            : '/exchange/odds/eventType/2378962',
          headers: {
            authorization: localStorage.getItem('accessToken')
          }
        })
        this.electionEventsCount = responseElection.data.result.length
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    }
  }
}
</script>
<style scoped>
.v-list-item--dense,
.v-list--dense .v-list-item {
  min-height: 52px;
}

.theme--dark.v-list-item--active:hover::before,
.theme--dark.v-list-item--active::before {
  opacity: 0;
}

/* height */
.height-70 {
  height: 70px;
}
.primary-lighten {
  background: rgba(68, 68, 68, 0.5);
}
</style>
